import { format as dateFormat } from 'date-fns';
import { enUS } from 'date-fns/locale/en-US';
import { pl } from 'date-fns/locale/pl';
const formats = {
    /** Short date format, ie 04/29/1453 */
    shortDate: 'P',
    /** Short date format, ie April 29th, 1453 */
    longDate: 'PPP',
    /** Short time format, ie 12:00 */
    shortTime: 'p',
    /** Short time format, ie 12:00:00 */
    longTime: 'pp',
    /** Short time format, ie 04/29/1453, 12:00:00 */
    shortDateTime: 'Ppp',
    /** Long time format, ie  April 29th, 1453, 12:00:00 */
    longDateTime: 'PPPpp',
};
const locales = {
    en: enUS,
    pl,
};
/**
 * Formats a date using one of the predefined named formats (short/long date, time, or date-time).
 * Rendered in the locale corresponding to `lang`, falling back to English for languages without
 * a dedicated date-fns locale.
 * @util
 * @__NO_SIDE_EFFECTS__
 */
export function formatDate(date, format, lang) {
    if (date === null || date === undefined || date === '') {
        return '';
    }
    return dateFormat(date, formats[format], { locale: locales[lang] ?? enUS });
}
//# sourceMappingURL=formatDate.js.map